import * as React from "react";
import LegalPage from "./LegalPage";
import type { LegalSection } from "./LegalPage";
import { CONTACT_EMAIL, LEGAL_LAST_UPDATED, OPERATOR_ADDRESS, OPERATOR_NAME } from "./legalDetails";

// The provider identification German law requires of a company website
// (the "Impressum", § 5 DDG).
const intro = "Information about the provider of Stellaris Mission Control in accordance with § 5 of the German Digital Services Act (DDG).";

const sections: LegalSection[] = [
  {
    title: "Provider",
    body: [OPERATOR_NAME, OPERATOR_ADDRESS],
  },
  {
    title: "Contact",
    body: [`Email: ${CONTACT_EMAIL}`],
  },
];

export default function LegalNotice(props: { handlePageChange: (page: string) => void }) {
  return (
    <LegalPage
      title="Legal Notice"
      updated={LEGAL_LAST_UPDATED}
      intro={intro}
      sections={sections}
      handlePageChange={props.handlePageChange}
    />
  );
}
